- name: icon-linkedin
  url: https://www.linkedin.com/in/kei18/
- name: icon-twitter
  url: https://twitter.com/_kei18
- name: icon-youtube
  url: https://www.youtube.com/@keisuke_okumura
- name: icon-github
  url: https://github.com/Kei18
- name: ai-google-scholar-square
  url: https://scholar.google.com/citations?user=4dFSWwMAAAAJ
